import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from './user.service';

@Injectable()
export class PermissionGuard  {

    constructor(private userService: UserService) { }

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const permissionName = next.data.permissionName;
        if (next.data.isEnvironment) {
            const environmentId = next.params.id;
            return this.userService.hasEnvironmentPermission(environmentId, permissionName);
        }
        else {
            return this.userService.hasPermission(permissionName);
        }
    }
}
